import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EventService } from '../../services/event.service';
import { Event } from '../../models/event.model';
import { US_STATES } from '../../constants/states.constants';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-home',
  imports: [CommonModule, FormsModule],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class HomeComponent implements OnInit, OnDestroy {
  loading = false;
  error: string | null = null;
  
  selectedEventType: 'live' | 'virtual' | null = null;
  eventCode: string = '';
  state: string = '';
  
  readonly stateOptions = US_STATES;
  
  private destroy$ = new Subject<void>();

  constructor(
    private eventService: EventService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      const code = params['code'];
      const state = params['state'];
      
      if (code) {
        this.eventCode = code;
        this.state = state || '';
        this.searchEventByCode(code, state);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  clickedEvent(id: string) {
    if (id === 'live_button') {
      this.selectedEventType = 'live';
    } else {
      this.selectedEventType = 'virtual';
    }
  }

  searchEventByCode(code: string, state?: string) {
    const originalCode = code;

    this.error = null;
    this.loading = true;

    this.eventService.searchEventByCode(code, state).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (events) => {
        this.loading = false;
        if (!events || events.length === 0) {
          this.error = `No event found with code "${originalCode}". Please check the code and try again.`;
          return;
        }
        
        const event = events[0];
        if (event.token) {
          this.router.navigate(['/register'], {
            queryParams: { 
              token: event.token
            }
          });
        } else {
          this.error = `No registration token available for event "${originalCode}". Please contact support.`;
        }
      },
      error: (err) => {
        this.loading = false;
        const backendMessage = err.error?.error?.message;
        if (err.status === 404) {
          this.error = backendMessage || `No event found with code "${originalCode}". Please check the code and try again.`;
        } else if (err.status === 400) {
          this.error = backendMessage || 'Invalid request. Please check the code and try again.';
        } else {
          this.error = backendMessage || 'An error occurred while searching for the event. Please try again.';
        }
        console.error('Error searching event:', err);
      }
    });
  }

  onSubmitCode() {
    if (this.eventCode) {
      this.searchEventByCode(this.eventCode, this.state || undefined);
    }
  }
}
